import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import withSounds from 'containers/withSounds';
import Countdown from 'react-countdown-now';
import { padNumber, fromIso9075DateString } from 'utils/functions';
import { tournamentShape } from 'utils/shapes';
import { TOURNAMENT_LIST_BUTTONS, TOURNAMENT_STATUSES } from 'utils/messages';
import { GAME_IMAGES } from 'components/GameIcon';
import {
  TOURNAMENT_LIST_BUTTON_CLASSES,
  TOURNAMENT_STATUS_COMPLETED,
  TOURNAMENT_STATUS_IN_PROGRESS,
  TOURNAMENT_STATUS_UPCOMING
} from 'utils/constants';
import ScalingTextBlock from 'components/ScalingTextBlock';
import moment from 'moment';

const wrapWithSounds = withSounds({ mouseEnterSound: true });
const ButtonWithSounds = wrapWithSounds(Button);

const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <span>
      {padNumber(days)}:{padNumber(hours)}:{padNumber(minutes)}:{padNumber(seconds)}
    </span>
  );
};

function getButtonText(status) {
  return TOURNAMENT_LIST_BUTTONS[status];
}

function getButtonColor(status) {
  return TOURNAMENT_LIST_BUTTON_CLASSES[status];
}

class TournamentRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      browserMillis: moment().valueOf()
    };
  }

  componentWillReceiveProps(nextProps) {
    const { tournaments } = nextProps;
    const { browserMillis } = this.state;

    if (tournaments && browserMillis === 0) {
      this.setState({
        browserMillis: moment().valueOf()
      });
    }
  }

  render() {
    const { status, tournaments, onInteraction, isMobile } = this.props;
    const { browserMillis } = this.state;

    return (
      <div className="tournament-list">
        {tournaments &&
          tournaments.length === 0 && (
            <div className="block">
              <h4>{`No ${TOURNAMENT_STATUSES[status]} tournaments`}</h4>
            </div>
          )}
        {tournaments.map((tournament, index) => {
          return (
            <div className="tournament-row" key={tournament.id}>
              <div
                className="tournament-panel image"
                onMouseEnter={onInteraction}
              >
                <img
                  src={GAME_IMAGES[tournament.game.name]}
                  alt={tournament.game.displayName}
                />
              </div>
              <div
                className="tournament-panel details middle"
                onMouseEnter={onInteraction}
              >
                <p className="bold header tournament-name" key={index.id}>
                  {tournament.name}
                </p>
                {getTimer(tournament, browserMillis)}
              </div>
              <div
                className="tournament-panel details"
                onMouseEnter={onInteraction}
              >
                <p className="bold prize">Prize</p>
                <ScalingTextBlock cssClass="bold yellow" maxHeight="4.5em">
                  {tournament.description}
                </ScalingTextBlock>
              </div>
              {getButton(tournament, isMobile)}
              {getStartTime(tournament)}
            </div>
          );
        })}
      </div>
    );
  }
}

function getTimer(tournament, browserMillis) {
  if (tournament.status === TOURNAMENT_STATUS_COMPLETED) {
    return <div />;
  }

  const isInProgress = tournament.status === TOURNAMENT_STATUS_IN_PROGRESS;
  const tournamentTime = isInProgress
    ? tournament.endTime
    : tournament.startTime;
  const tournamentMillis = moment.utc(tournamentTime).valueOf();
  const serverMillis = parseInt(tournament.serverTime, 10);

  const countdown = tournamentMillis - serverMillis + browserMillis;

  return (
    <div>
      <p className={isInProgress ? 'in-progress time' : 'time'}>
        {tournament.status === TOURNAMENT_STATUS_IN_PROGRESS
          ? 'Time Remaining: '
          : 'Starting In: '}
      </p>
      <p className={isInProgress ? 'in-progress time countdown' : 'time'}>
        <Countdown date={countdown} renderer={renderer} />
      </p>
    </div>
  );
}

function getStartTime(tournament) {
  if (tournament.status !== TOURNAMENT_STATUS_UPCOMING) {
    return <div />;
  }
  const startTime = moment.utc(tournament.startTime);

  return (
    <div className="tournament-panel details">
      <p className="time">
        Starts on:<br />
        {startTime.local().format('LLL')}
      </p>
    </div>
  );
}

function getButton(tournament, isMobile) {
  if (tournament.status === TOURNAMENT_STATUS_UPCOMING) {
    return '';
  } else if (tournament.status === TOURNAMENT_STATUS_COMPLETED) {
    return (
      <Button
        className={getButtonColor(tournament.status)}
        href={''}
        disabled={true}
        value={getButtonText(tournament.status)}
      />
    );
  } else {
    return (
      <ButtonWithSounds
        className={getButtonColor(tournament.status)}
        href={`${isMobile
          ? '/mobile/tournaments/gametournament'
          : '/tournament'}/${tournament.id}`}
        disabled={false}
        value={getButtonText(tournament.status)}
      />
    );
  }
}

TournamentRow.propTypes = {
  status: PropTypes.string,
  tournaments: PropTypes.arrayOf(tournamentShape),
  onInteraction: PropTypes.func,
  isMobile: PropTypes.bool
};

export default TournamentRow;



// WEBPACK FOOTER //
// ./src/containers/TournamentList/TournamentRow.js